// extracted by mini-css-extract-plugin
module.exports = {"pintxo-badge":"Badge_pintxo-badge__BO_1D","pintxo-badge-wrapper__badge__value":"Badge_pintxo-badge-wrapper__badge__value__l5fc8"};